import _ from '@lodash';
import { setDefaultSettings } from 'app/store/actions/fuse';
export const GET_USER_DATA = '[USER] GET DATA';
export const SET_USER_DATA = '[USER] SET DATA';
export const REMOVE_USER_DATA = '[USER] REMOVE DATA';
export const USER_LOGGED_OUT = '[USER] LOGGED OUT';
export const SET_PRELOAD_AUTH = '[USER] SET PRELOAD AUTH';
export const SET_ORGANIZACOES = '[USER] SET ORGANIZACOES';

const ListState = [
    "idconfiguracao",
    "idpessoa"
];

export function setUserData(user, access_token, status_xapp) {
    return (dispatch) => {
        user.data.settings.theme = {
            main: user.data.settings.theme,
            footer: user.data.settings.theme,
            toolbar: user.data.settings.theme,
            navbar: user.data.settings.theme
        };
        dispatch(setDefaultSettings(user.data.settings));

        dispatch({
            type: SET_USER_DATA,
            payload: user,
            access_token: access_token,
            status_xapp: status_xapp,
        })
    }
}

export function updateUserSettings(settings) {
    return (dispatch, getState) => {
        const oldUser = getState().auth.user;
        const user = _.merge({}, oldUser, { data: { settings } });

        updateUserData(user);

        return dispatch(setUserData(user));
    }
}

export function removeUserData() {
    return {
        type: REMOVE_USER_DATA
    }
}

function updateUserData(user) {
    if (user.role === 'guest') {
        return;
    }
}

export function setPreloadAuth(_AValue) {
    return {
        type: SET_PRELOAD_AUTH,
        preload: _AValue
    }
}

export function setOrganizacoes(_AValue) {
    return {
        type: SET_ORGANIZACOES,
        preload: _AValue
    }
}
